(function () {
    'use strict';

    angular
        .module('app')
        .factory('sendtoservice', sendtoservice);

    sendtoservice.$inject = ['$http', '$q'];

    function sendtoservice($http, $q) {
        var service = {
            sendto: sendTo,
            getNotificationEmailBody: getNotificationEmailBody,
            generateNotificationId: generateNotificationId,
            getNotificationEmailSubject: getNotificationEmailSubject
        };
        return service;

        // **************************************
        // BEGIN COMMANDS
        // **************************************

        // Need to get a server side generated GUID for the new (not yet created) container
        // So that the email message body has the ID.
        function generateNotificationId() {
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/NotificationLists/GenerateListId/').then(function (response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        // Get's the custom subject (or default)
        function getNotificationEmailSubject(selectionList) {
            var deferred = $q.defer();
            $http.post('../Synergis.WebApi/api/NotificationLists/EmailSubjectSendTo',
                JSON.stringify(selectionList),
                { headers: { "Content-Type": "application/json" } }).then(function (response) {
                    console.log("request good");
                    deferred.resolve(response.data);
                }, function (error) {
                    console.log("request failed");
                    deferred.reject(error);
                });
            /*
            $http.get('../Synergis.WebApi/api/NotificationLists/EmailSubjectSendTo/').then(function (response) {
                deferred.resolve(response.data);
            });
            */
            return deferred.promise;
        }

        function getNotificationEmailBody(id) {
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/NotificationLists/AlsEmailNotification/' + id).then(function (response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        // Call the sendto command 
        function sendTo(sendToModel) {
            var deferred = $q.defer();

            //var request = $http({
            //    url: '../Synergis.WebApi/api/SelectionCommand/SendTo',
            //    method: 'POST',
            //    data: JSON.stringify(sendToModel),
            //    headers: {
            //        "Content-Type": "application/json"
            //    }
            //});

            $http.post('../Synergis.WebApi/api/SelectionCommand/SendTo', JSON.stringify(sendToModel), { headers: { "Content-Type": "application/json" } }).then(function (response) {
                console.log("request good");
                deferred.resolve(response);
            }, function (error) {
                console.log("request failed");
                deferred.reject(error);
            });

            //request.then(function (response) {
            //    console.log("request good");
            //    deferred.resolve(response);
            //}, function (response) {
            //    console.log("request failed");
            //    deferred.reject(response);
            //});


            return deferred.promise;
        }
    }
})();